const metricsKeyMapping = {
	SKILL: 'skill',
	MORALE: 'morale',
	MVP: 'pa',
	CS: 'cs',
	QUALITY: 'quality',
	THROUGHPUT: 'throughput',
	BUDGET: 'budget',
	VELOCITY: 'velocity',
	ACCURACY: 'accuracy',
	EFFICIENCY:'efficiency'
}

export default metricsKeyMapping;